;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"4675Fde95MQrdI8l9LTfn"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

import {
  CHUNK_LOAD_ERROR_PATTERNS,
  CORE_ERROR_PATTERNS,
  createBeforeSend,
  INDEXEDDB_ERROR_PATTERNS,
  WHALE_BROWSER_ERROR_PATTERNS,
} from '@zep/sentry';

import { ApiTokenStorage } from '@/module/auth';

import baseOptions from './sentry.base.config';

// ZEP-591 EKS 카나리 관측: quiz 는 청크 로드 실패가 실제 유저 영향(백지)이고,
// 카나리 중 buildId 스큐(구/신 빌드 혼입)의 1차 신호이므로 quiz 만 청크 에러를 관측한다.
// ZEP-655 로 부팅 전 청크 실패 자동복구(cache-bust 리로드)를 갖췄고, 복구 결과
// (cache-bust/failed)를 관측해야 하므로 계속 preserve 한다 — 특히 'failed' 가 램프업 게이트.
// preservePatterns 는 ignorePatterns 판정보다 우선하는 allowlist 다.
// CHUNK 서브셋을 ignorePatterns 에서 "빼는" 방식은 substring 매칭 특성상
// 상위 패턴이 삼키는 구멍이 있다 — 실측: NETWORK 의 'Failed to fetch' 가
// 'Failed to fetch dynamically imported module' 메시지를 드롭시킴.
// beforeSend 의 applyChunkLoadFingerprint 가 chunk_recovery 태그로 이슈를 단계 분리한다.
Sentry.init({
  ...baseOptions,
  beforeSend: createBeforeSend({
    ignorePatterns: [
      ...CORE_ERROR_PATTERNS,
      ...WHALE_BROWSER_ERROR_PATTERNS,
      ...INDEXEDDB_ERROR_PATTERNS,
    ],
    preservePatterns: CHUNK_LOAD_ERROR_PATTERNS,
    authStateResolver: () =>
      ApiTokenStorage.get() ? 'authenticated' : 'guest',
  }),
  enableTracing: false, // 성능 하락 방지를 위해 비활성화
});
